import { Box, Button, Container, TextField, Typography } from '@mui/material';
import { Formik, ErrorMessage, Form } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { primaryColor } from '../../Styles/styles';
import axios from 'axios';

const AdminLogin = () => {
    
    const navigate = useNavigate()
    const validationSchema = Yup.object().shape({
        username: Yup.string().required('Full Name is required'),
        password: Yup.string().required('Password is required')
    })
    const initialValues = {
        username: '',
        password: ''
    };

    const handleSubmit = async(values: any) => {
        try {
            console.log('values', values)
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/admin-login`, values)
            localStorage.setItem('adminToken',response.data.data.token)
            navigate("/adminHome")

        } catch (error: any) {
            console.log("🚀 ~ handleSubmit ~ error:", error.response.data.message)
            alert(error.response.data.message || "Bad Request")
        }
    }
    return (

        <Box sx={{ width: '100vw', height: '100vh', bgcolor: '#f7f7f7', display: 'flex', justifyContent: 'center', alignItems: 'flex-start' }}>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {(formik) => (

                    <Form onSubmit={formik.handleSubmit}>
                        <Container sx={{ width: '552px', height: '350px', top: '308px', left: '677px', borderRadius: '10px 0px 0px 0px', bgcolor: '#FFFFFF', display: 'flex', flexDirection: 'column', justifyContent: 'space-around', alignItems: 'center', padding: '20px', marginTop: '20vh' }}>
                            <Typography sx={{ fontFamily: 'Montserrat', fontSize: '40px', fontWeight: '500', lineHeight: '29px', textAlign: 'center', color: '#6E6E6E' }}>Login</Typography>
                            <TextField
                                sx={{ marginTop: '2%', width: '370px', '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#D9D9D9' }, '& .MuiFormHelperText-root': { color: 'red' }, borderRadius: '10px' }}
                                id="username"
                                name="username"
                                placeholder='Username'
                                value={formik.values.username}
                                onChange={formik.handleChange}
                                helperText={<ErrorMessage name="username" />}
                            />
                            <TextField
                                sx={{ marginTop: '-2%', width: '370px', '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#D9D9D9' }, '& .MuiFormHelperText-root': { color: 'red' }, borderRadius: '10px' }}
                                id="password"
                                name="password"
                                placeholder='Password'
                                type='password'
                                value={formik.values.password}
                                onChange={formik.handleChange}
                                helperText={<ErrorMessage name="password" />}
                            />
                            <Button
                                color="primary"
                                variant="contained"
                                type="submit"
                                sx={{
                                    height: '55px',
                                    width: '187px',
                                    fontSize: '16px',
                                    backgroundColor: primaryColor,
                                    ":hover": { backgroundColor: primaryColor },
                                    borderRadius: '47px'
                                }}
                            >
                                Save
                            </Button>
                        </Container>
                    </Form>
                )}
            </Formik>
        </Box>
    )
}

export default AdminLogin